import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../../chunks/tslib.es6.js";
import e from "../../core/Accessor.js";
import "../../core/has.js";
import { property as o } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as i } from "../../core/accessorSupport/decorators/subclass.js";
import { M as r } from "../../chunks/MultipointDrawAction.js";
import { PointDrawAction as s } from "./PointDrawAction.js";
import { PolygonDrawAction as c } from "./PolygonDrawAction.js";
import { PolylineDrawAction as n } from "./PolylineDrawAction.js";
import { SegmentDrawAction as a } from "./SegmentDrawAction.js";

var p = /*#__PURE__*/function (_e) {
  _inherits(p, _e);

  var _super = _createSuper(p);

  function p() {
    var _this;

    _classCallCheck(this, p);

    _this = _super.apply(this, arguments), _this.activeAction = null, _this.type = "draw", _this.view = null;
    return _this;
  }

  _createClass(p, [{
    key: "destroy",
    value: function destroy() {
      this.activeAction && (this.activeAction.destroy(), this.activeAction = null);
    }
  }, {
    key: "create",
    value: function create(t, e) {
      this.reset();

      var o = _objectSpread({
        view: this.view
      }, e);

      switch (t) {
        case "point":
          o.editGeometryType = "point", this.activeAction = new s(o);
          break;

        case "polyline":
          o.editGeometryType = "polyline", this.activeAction = new n(o);
          break;

        case "multipoint":
          o.editGeometryType = "polygon", this.activeAction = new r(o);
          break;

        case "polygon":
          o.editGeometryType = "polygon", this.activeAction = new c(o);
          break;

        case "rectangle":
        case "circle":
        case "ellipse":
        case "triangle":
          o.editGeometryType = "polygon", this.activeAction = new a(o);
      }

      return this.activeAction;
    }
  }, {
    key: "complete",
    value: function complete() {
      this.activeAction && this.activeAction.complete(), this.activeAction = null;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.activeAction && this.activeAction.destroy(), this.activeAction = null;
    }
  }]);

  return p;
}(e);

t([o()], p.prototype, "activeAction", void 0), t([o({
  readOnly: !0
})], p.prototype, "type", void 0), t([o()], p.prototype, "view", void 0), p = t([i("esri.views.draw.Draw")], p);
var l = p;
export { l as default };